import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { style } from './zui-multipicker-item-css.js';
import '@zywave/zui-icons';
import '@zywave/zui-button';

/**
 * Individual 'pickers' that are inserted into `<zui-multipicker>`.
 * @element zui-multipicker-item
 *
 * @cssprop [--zui-multipicker-item-font-size=inherit] - If necessary, this property exists for font size control; by default it should `inherit` successfully
 *
 * @slot - Default, unnamed slot; for inserting content, such as a title or a small icon, into `<zui-multipicker-item>`
 *
 * @event {CustomEvent} change - Event dispatches when the `selected` value changes; details contain information about which `identifier` and its `selected` value
 */
export class ZuiMultipickerItem extends ZuiBaseElement {
  /**
   * A unique `identifier` to specify the current picker
   */
  @property({ type: String }) identifier: string | undefined = undefined;

  /**
   * Reflects `selected` state of current picker
   */
  @property({ type: Boolean, reflect: true }) selected = false;

  static get styles() {
    return [super.styles, style];
  }

  render() {
    return html`
      <div class="item">
        <div class="content"><slot></slot></div>

        <button class="${this.selected ? 'red' : 'green'}" @click="${this.select}"
          ><zui-icon icon="${this.selected ? 'zui-indicator-remove' : 'zui-indicator-add'}"></zui-icon
        ></button>
      </div>
    `;
  }

  /**
   * Toggles picker's `selected` state to opposite value
   */
  select(): void {
    this.selected = !this.selected;
    this.dispatchEvent(
      new CustomEvent('change', {
        bubbles: true,
        composed: true,
        detail: { identifier: this.identifier, selected: this.selected },
      })
    );
  }
}

window.customElements.define('zui-multipicker-item', ZuiMultipickerItem);

declare global {
  interface HTMLElementTagNameMap {
    'zui-multipicker-item': ZuiMultipickerItem;
  }
}
